import type { LiveUiNoTeam } from '@/types';
import {
  OVERLAY_TRANSPARENCY,
  SponsorStrip,
  Wordmark,
} from '../components/overlay';

// GET /:eventSlug/live/ui/no-team — the wordmark and the sponsor strip, for the scenes
// with nobody on stage. Nothing is polled here.
export default function NoTeam({ overlay }: LiveUiNoTeam) {
  return (
    <>
      <style>{OVERLAY_TRANSPARENCY}</style>
      <div className="fixed inset-0 overflow-hidden">
        <Wordmark overlay={overlay} />
        <div className="absolute inset-x-0 bottom-0">
          <SponsorStrip overlay={overlay} />
        </div>
      </div>
    </>
  );
}
